import {Component, EventEmitter, Input, OnDestroy, Output} from '@angular/core';
import {InfoMessage} from "../../interfaces/info-message";
import {finalize, takeUntil} from "rxjs/operators";
import {BaseService} from "../../services/base.service";
import {Subject} from "rxjs";
import {HttpClient} from "@angular/common/http";
import * as moment from "moment";

@Component({
  selector: 'app-modal-message',
  templateUrl: './modal-message.component.html',
  styleUrls: ['./modal-message.component.scss']
})
export class ModalMessageComponent extends BaseService implements OnDestroy{
  @Input() infoMessage: InfoMessage;

  @Output() modalInfoMessageConfirm: EventEmitter<boolean> = new EventEmitter<boolean>();

  public isDestroyed: Subject<boolean> = new Subject();
  public isModalMessage: boolean = false;
  public isDarkBackgroundNotHide: boolean = false;
  public isSending: boolean = false;

  constructor(
    private http: HttpClient
  ) {
    super();
  }

  infoMessageRead(id: number) {
    // Подвійний клік слав два запити, і повідомлення потрапляло в «Повідомлення» двічі
    if (this.isSending) {
      return;
    }

    this.isSending = true;

    this.http.post(this.apiRoot + 'header/message_notified', {
      message_id: id
    })
      .pipe(
        takeUntil(this.isDestroyed),
        // знімаємо і після помилки: інакше модалку вже не закрити, бо іншої кнопки в ній немає
        finalize(() => this.isSending = false)
      )
      .subscribe(() => {
        this.isDarkBackgroundNotHide = false;
        this.isModalMessage = false;

        this.modalInfoMessageConfirm.emit();
      });
  }

  getNewMessageShow() {
    this.http.get(this.apiRoot + 'header/get_new_messages')
      .pipe(takeUntil(this.isDestroyed))
      .subscribe((data: InfoMessage) => {
        if (data) {
          data.text = data.text.replace(/\d{4}-\d{2}-\d{2}/g, (date) => moment(date).format('DD.MM.YYYY'));
          this.infoMessage = data;
          this.isModalMessage = true;
          this.isDarkBackgroundNotHide = true;
        }
      });
  }

  ngOnDestroy() {
    this.isDestroyed.next(true);
    this.isDestroyed.complete();
  }
}
